import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.spacing(60),
    margin: 'auto',
  },
  title: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
  },
}));
export const PrivacyPolicyPage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h5" component="div" className={classes.title}>
        FlashyPlayer Privacy Policy
      </Typography>
      <Typography>FlashyPlayer does not collect any personal data.</Typography>
    </div>
  );
};
